'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _autoPopModal = require('../../../redux/modules/autoPopModal');

var _redux = require('redux');

var _react = require('react');

var _reactRedux = require('react-redux');

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _modal = require('../../../redux/modules/modal');

var _browser = require('../../../redux/modules/browser');

var _user = require('../../../redux/modules/user');

var _enums = require('../../../enums');

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AutoPopModalContainer = (_dec = (0, _reactRedux.connect)(function (state) {
    var isMobile = !!(0, _browser.isUiMobile)(state);
    var openModal = (0, _modal.getOpenModal)(state);
    var userLoggedIn = (0, _user.isUserLoggedIn)(state);
    var modalShown = (0, _autoPopModal.getUiModalShown)(state);
    var lastDateShown = (0, _autoPopModal.getUiDateLastShown)(state);
    var preventAutoPopup = (0, _autoPopModal.shouldStopAutoPopup)(state);
    return {
        isMobile: isMobile,
        lastDateShown: lastDateShown,
        modalShown: modalShown,
        openModal: openModal,
        preventAutoPopup: preventAutoPopup,
        userLoggedIn: userLoggedIn
    };
}, function (dispatch) {
    return (0, _redux.bindActionCreators)({
        autoOpenCreateAccountModal: _autoPopModal.autoOpenCreateAccountModal
    }, dispatch);
}), _dec(_class = function (_Component) {
    (0, _inherits3.default)(AutoPopModalContainer, _Component);

    function AutoPopModalContainer() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, AutoPopModalContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoPopModalContainer.__proto__ || (0, _getPrototypeOf2.default)(AutoPopModalContainer)).call.apply(_ref, [this].concat(args))), _this), _this.onScroll = function (e) {
            e.preventDefault();
            _this.props.autoOpenCreateAccountModal();
            window.removeEventListener('scroll', _this.onScroll);
        }, _this.onTouchMove = function (e) {
            e.preventDefault();
            _this.props.autoOpenCreateAccountModal();
            window.removeEventListener('touchmove', _this.onTouchMove);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(AutoPopModalContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props = this.props,
                isMobile = _props.isMobile,
                modalShown = _props.modalShown,
                openModal = _props.openModal,
                preventAutoPopup = _props.preventAutoPopup,
                userLoggedIn = _props.userLoggedIn;


            var shouldShowModal = !preventAutoPopup && !modalShown && openModal === _enums.modalTypes.NONE && !userLoggedIn;

            if (shouldShowModal) {
                if (isMobile) {
                    window.addEventListener('touchmove', this.onTouchMove);
                } else {
                    window.addEventListener('scroll', this.onScroll);
                }
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props2 = this.props,
                lastDateShown = _props2.lastDateShown,
                userLoggedIn = _props2.userLoggedIn,
                modalShown = _props2.modalShown;


            if (!userLoggedIn && nextProps.userLoggedIn) {
                var expires = new Date();
                expires.setDate(expires.getDate() + 60);
                _reactCookie2.default.save('bidder-has-logged-in', true, {
                    domain: '.liveauctioneers.com',
                    expires: expires,
                    path: '/'
                });
            }

            if (!modalShown && nextProps.modalShown || lastDateShown !== nextProps.lastDateShown) {
                var _expires = new Date();
                _expires.setDate(_expires.getDate() + _autoPopModal.DAYS_TO_WAIT_TO_SHOW_MODAL_AGAIN);
                _reactCookie2.default.save('join-modal-last-seen', (0, _momentTimezone2.default)().format('YYYY-MM-DD'), {
                    domain: '.liveauctioneers.com',
                    expires: _expires,
                    path: '/'
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);
    return AutoPopModalContainer;
}(_react.Component)) || _class);
exports.default = AutoPopModalContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modals/AutoPopModal/AutoPopModalContainer.js
// module id = FHLC
// module chunks = 57